"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const functions_1 = require("../../functions");
function propertyDefinition(pvs) {
    const inputTemperatures = (0, functions_1.getInputTemperatures)(pvs);
    return [
        ...inputTemperatures.map((_, i) => ({
            sort_no: i,
            name: (0, functions_1.inputTemperatureName)(i),
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("stepproperty=1"),
            value: [],
            fieldName: functions_1.inputTemperaturePrefix
        }))
    ];
}
//# sourceMappingURL=input-temperatures-definition.js.map